import React from 'react';
import { ReactComponent as AdaptIcon } from 'Assets/svg/adapt-logo.svg';
import { ReactComponent as SwapIcon } from 'Assets/svg/swap.svg';

const CRMExportHeader = props => {
  const { Logo, title, message } = props;

  return (
    <div className="header-wrap">
      <div className="icon-wrap">
        <div className="icon-box">
          <AdaptIcon />
        </div>
        <SwapIcon className="swap-icon" />
        <div className="icon-box">
          <Logo className="logo" />
        </div>
      </div>
      <div className="title">{title}</div>
      <div className="message">{message}</div>
    </div>
  );
};

export default CRMExportHeader;
export { CRMExportHeader };
